export class VeiculosModel {
  id_veiculo: number;
  marca: string;
  modelo: string;
  placa: string;
  renavam: string;
  troca_oleo: string;
  km_troca_oleo: string;
  extintor: string;
  validade_extintor: string;
  trocar_oleo_cada_km: number = 5000;
}



// WEBPACK FOOTER //
// ./src/app/veiculos/veiculos.model.ts